export const FEATURE_FLAGS = Object.freeze({
  PUBLIC_CASE_INDEX: false,
  AUTO_NEWS_INGEST: false,
  GENERAL_ARTICLE_FETCH: false,
  POLITICAL_SHARE: false,
  PUBLIC_COMMENTS: false,
  PUBLIC_CASE_APP: true,
  CLAIM_PACKET_SALE: false,
  PRO_ENTITLEMENT: false,
} as const);
